export default __webpack_public_path__ + "static/media/CSS.6925cf14.webp";